export { default } from "./visuallyHidden.mjs";